<div class="flex-column h-100">
  <app-portal-header [displayRightMenu]="false" [displayRightLogo]="true" [displayCalendarIcon]="false"></app-portal-header>
  <div class="flex-row w-100 h-100 justify-content-center">
    <form [formGroup]="form" [class.error]="!form.valid && form.touched" autocomplete="off" (ngSubmit)="submit()"
          class="flex-column form-window grey-box dense-5">
      <div *ngIf="success" class="alert alert-success">You will receive an e-mail with a link to retrieve your
        password shortly.
      </div>
      <mat-label class="main-text-font text-sm mt-2 mb-1">Please enter your e-mail address to retrieve your password</mat-label>
      <mat-form-field class="styled mb-3 email" appearance="outline">
        <input type="text" matInput formControlName="email" placeholder="Email">
        <mat-error *ngIf="email?.errors">
          This e-mail is invalid. Please enter a valid email
        </mat-error>
      </mat-form-field>

      <div class="mt-1">
        <button mat-stroked-button class="styled primary me-1" [disabled]="loading || !form.valid">Submit
        </button>
        <button mat-stroked-button class="styled secondary" routerLink="/"
                [disabled]="loading">Cancel
        </button>
      </div>
    </form>
  </div>
  <app-main-footer></app-main-footer>
</div>
